import { render, staticRenderFns } from "./marKetingLotteryRecord.vue?vue&type=template&id=2d00b81e&scoped=true&"
import script from "./marKetingLotteryRecord.vue?vue&type=script&lang=js&"
export * from "./marKetingLotteryRecord.vue?vue&type=script&lang=js&"
import style0 from "./marKetingLotteryRecord.vue?vue&type=style&index=0&id=2d00b81e&scoped=true&lang=css&"
import style1 from "./marKetingLotteryRecord.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d00b81e",
  null
  
)

export default component.exports